import store from '../store';

const getStoreByPath=path=>
    path.replace(/[[]/g,'.').replace(/[\]]/g,'').split('.').reduce((scope,key) => scope[key],store.getState());

export default getStoreByPath;